import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import classNames from 'classnames'
import { phones } from 'helpers/phones'
import React, { FormEvent } from 'react'
import { useActions, useAppSelector, useThunkDispatch } from 'store/hooks'
import { Button, FormControl, InputLabel, OutlinedInput } from 'ui'
import { LoaderInCentalPosition, TextMaskPhone } from 'widget'

import { ReqCounter } from 'widget/SmsCodeConfirm/components/ReqCounter/ReqCounter'

import style from './AuthForm.module.scss'
import { getAuthSms } from './redux/action/getAuthSms'
import { SmsBlockType } from './redux/authSlice'

// форма авторизации пользователя
export const AuthPhoneForm = () => {
  const [hasError, setHasError] = React.useState<boolean>(false)
  const [isButtonDisabled, setButtonDisabled] = React.useState<boolean>(true)
  const thunkDispatch = useThunkDispatch()
  const { authInfo, userInfo, smsInfo } = useAppSelector(state => state.auth)

  const { setUserInfo, setSmsInfo } = useActions()

  React.useEffect(() => {
    setUserInfo({ phone: '' })
  }, [])

  const handleChange = (event: { target: { value: string } }) => {
    setUserInfo({ phone: event.target.value })
    setSmsInfo({ blockType: null, blockTime: 0 })
  }

  const checkPhoneLength = (phoneNumber: string) => {
    const numbersOnly = phones(phoneNumber)
    return numbersOnly?.length !== 11
  }

  const handleBlur = () => {
    setHasError(checkPhoneLength(userInfo.phone))
  }

  React.useEffect(() => {
    setButtonDisabled(checkPhoneLength(userInfo.phone))
    setHasError(false)
  }, [userInfo.phone])

  const submitHandler = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    thunkDispatch(getAuthSms(userInfo.phone))
  }

  return (
    <>
      <div className={classNames(style.formWrapper, 'mt24')}>
        <form className={style.authForm} noValidate onSubmit={submitHandler}>
          <p className='h1'>Вход или регистрация</p>
          <p className={classNames(style.subtitle, 'mb24')}>
            Введите номер телефона
          </p>

          <FormControl className={style.authFormControl} error={hasError}>
            <InputLabel htmlFor='phone-mask-input'>Номер телефона</InputLabel>
            <OutlinedInput
              label='Номер телефона'
              fullWidth
              type='tel'
              value={userInfo.phone}
              id='phone-mask-input'
              autoFocus
              onChange={handleChange}
              onBlur={handleBlur}
              inputProps={{
                inputprops: { min: 18 },
                'data-testid': 'login-phone-input',
              }}
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              inputComponent={TextMaskPhone as any}
            />
          </FormControl>

          <ReqCounter />

          <Button
            className={style.btn}
            type='submit'
            variant='contained'
            disabled={
              isButtonDisabled ||
              authInfo.isLoading ||
              smsInfo.blockType === SmsBlockType.countLimit
            }
            endIcon={<ChevronRightIcon />}
            data-testid='login-phone-submit'
          >
            {authInfo.isLoading && (
              <LoaderInCentalPosition className={style.loader} />
            )}
            Получить код
          </Button>
        </form>
      </div>
    </>
  )
}
